export function shouldShowUploadPrefillPanel(args: {
  uploading: boolean;
  orderId?: string | null;
  guestToken?: string | null;
}): boolean {
  return Boolean(args.uploading && args.orderId && args.guestToken);
}
